import "./index.css";
import { Modal, Spin } from "antd";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { Routes } from "../../../../common/Routes";
import AuthZButton from "../../../../components/AuthzButton";
import { ConfirmMembershipController } from "./controller";
import { ErrKeys } from "./model";
import { KeyConditionAction } from "../model";
import { useIsIndividualInclusionNamingEnabled } from "../common/hooks/IsIndividualInclusionNamingEnabled";

const actionVerb = (action) => {
  if (action === KeyConditionAction.ADD) {
    return "added";
  } else if (action === KeyConditionAction.EDIT) {
    return "edited";
  } else if (action === KeyConditionAction.DELETE) {
    return "deleted";
  }
};

export const ConfirmMembership = ({ userGroupUniqueName }) => {
  const [visible, setVisible] = useState(true);
  const history = useHistory();
  const isIndividualInclusionNamingEnabled = useIsIndividualInclusionNamingEnabled();

  const {
    userGroupName,
    addedPeopleNum,
    isLoading,
    errors,
    removedPeopleNum,
    action,
    isSpecialCondition,
    userGroupTypeUniqueName,
    isNotificationEnabled,
  } = ConfirmMembershipController(userGroupUniqueName);

  const hasError = errors?.length > 0;

  const onClick = () => {
    setVisible(false);
    if (hasError && errors[0].errorKey !== ErrKeys.INVALID_CONDITION) {
      history.push(`${Routes.UserGroups.basePath}/${userGroupTypeUniqueName}`);
    } else {
      history.push(
        `${Routes.UserGroups.basePath}/${userGroupTypeUniqueName}/${userGroupUniqueName}`,
      );
    }
  };

  return (
    <div>
      {!isLoading ? (
        <Modal
          centered
          title={null}
          visible={visible}
          closeIcon={<div />}
          footer={null}
          onCancel={null}
          closable={false}
          maskClosable={false}
          className="confirm-modal-container"
        >
          {hasError ? (
            <p className="confirm-modal-header">Warning message</p>
          ) : (
            <p className="confirm-modal-header">Condition {actionVerb(action)} successfully!</p>
          )}

          <ConfirmModalBody
            errors={errors}
            userGroupName={userGroupName}
            addedPeopleNum={addedPeopleNum}
            removedPeopleNum={removedPeopleNum}
            action={action}
            isSpecialCondition={isSpecialCondition}
            isNotificationEnabled={isNotificationEnabled()}
            isIndividualInclusionNamingEnabled={isIndividualInclusionNamingEnabled}
          />

          <AuthZButton onClick={onClick} buttonClassName="authz-primary-button confirm-modal-ok">
            OK
          </AuthZButton>
        </Modal>
      ) : (
        <Spin spinning={true} style={{ width: "100%", height: "100%" }} />
      )}
    </div>
  );
};

const ConfirmModalBody = ({
  errors,
  userGroupName,
  addedPeopleNum,
  removedPeopleNum,
  action,
  isSpecialCondition,
  isNotificationEnabled,
  isIndividualInclusionNamingEnabled,
}) => {
  let renderContent = <div></div>;
  if (errors.length > 0) {
    if (errors[0].errorKey === ErrKeys.USER_GROUP_NOT_FOUND) {
      renderContent = (
        <div className="confirm-modal-body">
          <p>This business team does not exist.</p>
        </div>
      );
    } else if (errors[0].errorKey === ErrKeys.USER_GROUP_NO_PERMISSION) {
      renderContent = (
        <div className="confirm-modal-body">
          <p>You don't have the access to this business team.</p>
        </div>
      );
    } else if (errors[0].errorKey === ErrKeys.INVALID_CONDITION) {
      renderContent = (
        <div className="confirm-modal-body">
          <p>This condition does not exist anymore.</p>
        </div>
      );
    } else {
      renderContent = (
        <div className="confirm-modal-body">
          <p>{errors[0].errorMessage}</p>
        </div>
      );
    }
  } else {
    const shouldDisplayLoosingMembership = removedPeopleNum > 0;
    const shouldDisplayAddedMembership = addedPeopleNum > 0;

    function shouldDisplayNotificationMessage() {
      return (
        (shouldDisplayAddedMembership || shouldDisplayLoosingMembership) && isNotificationEnabled
      );
    }

    const gainingOrLoosingMembership = () => {
      if (shouldDisplayAddedMembership && shouldDisplayLoosingMembership) {
        return (
          <>
            <p>
              {addedPeopleNum} people are added as members to {userGroupName}.
            </p>
            <p>
              {removedPeopleNum} people lost access to {userGroupName}.
            </p>
          </>
        );
      } else if (shouldDisplayAddedMembership) {
        return (
          <p>
            {addedPeopleNum} people are added as members to {userGroupName}.
          </p>
        );
      } else if (shouldDisplayLoosingMembership) {
        return (
          <p>
            {removedPeopleNum} people lost access to {userGroupName}.
          </p>
        );
      } else {
        return null;
      }
    };

    function specialOrKeyCondition() {
      return isSpecialCondition
        ? isIndividualInclusionNamingEnabled
          ? "individual inclusion"
          : "special condition"
        : "key condition";
    }

    renderContent = (
      <div className="confirm-modal-body">
        <p>
          You have successfully {actionVerb(action)} the {specialOrKeyCondition()}.
        </p>
        {gainingOrLoosingMembership()}
        {shouldDisplayNotificationMessage() ? (
          <p>A notification has been sent to the members and the owners of the business team.</p>
        ) : null}
      </div>
    );
  }
  return renderContent;
};
